<div class="contact-upper-component field-font-small" style="width:100%;">
    <div class="field-group">
        <div>
            <mat-form-field class="field-medium-small">
                <mat-label>Poids (kg)</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.weight" (keyup)="setWeight($event)" name="weight" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>Taille (cm)</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.height" (keyup)="setHeight($event)"name="height" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>BMI</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.bmi" name="bmi" matInput>
            </mat-form-field>
        </div>  
        <div>
            <mat-form-field class="field-medium-small">
                <mat-label>Pouls</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.pulse" name="pulse" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>Saturation</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.saturation" name="saturation" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>Glycémie</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.bloodsugar" name="bloodsugar" matInput>
            </mat-form-field>
        </div>
    </div>
    <div class="field-group">
        <div>
            <mat-form-field class="field-medium-small">
                <mat-label>TA couché D</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.talyingdown_right1" name="talyingdown_right1" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>TA couché D</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.talyingdown_right2" name="talyingdown_right2" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>TA couché G</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.talyingdown_left1" name="talyingdown_left1" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>TA couché G</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.talyingdown_left2" name="talyingdown_left2" matInput>
            </mat-form-field>
        </div>  
        <div>
            <mat-form-field class="field-medium-small">
                <mat-label>TA debout D</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.tastanding_right1" name="tastanding_right1" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>TA debout D</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.tastanding_right2" name="tastanding_right2" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>TA debout G</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.tastanding_left1" name="tastanding_left1" matInput>
            </mat-form-field>
            <mat-form-field class="field-medium-small">
                <mat-label>TA debout G</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.tastanding_left2" name="tastanding_left2" matInput>
            </mat-form-field>
        </div>
    </div>
    <div class="field-group">
        <div>
            <mat-form-field class="field-medium-small">
                <mat-label>P. crânien (cm)</mat-label>
                <input class="" type="text" [(ngModel)]="contact.biometrics.cranialperimeter" name="cranialperimeter" matInput>
            </mat-form-field>
        </div>
    </div>
</div>